/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';

/**
 * 
 * @export
 * @interface UpdateBasketAddressModel
 */
export interface UpdateBasketAddressModel {
    /**
     * 
     * @type {Address}
     * @memberof UpdateBasketAddressModel
     */
    billingAddress: Address;
    /**
     * 
     * @type {Address}
     * @memberof UpdateBasketAddressModel
     */
    shippingAddress?: Address;
}

/**
 * Check if a given object implements the UpdateBasketAddressModel interface.
 */
export function instanceOfUpdateBasketAddressModel(value: object): boolean {
    if (!('billingAddress' in value)) return false;
    return true;
}

export function UpdateBasketAddressModelFromJSON(json: any): UpdateBasketAddressModel {
    return UpdateBasketAddressModelFromJSONTyped(json, false);
}

export function UpdateBasketAddressModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBasketAddressModel {
    if (json == null) {
        return json;
    }
    return {
        
        'billingAddress': AddressFromJSON(json['billingAddress']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
    };
}

export function UpdateBasketAddressModelToJSON(value?: UpdateBasketAddressModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'billingAddress': AddressToJSON(value['billingAddress']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
    };
}

